export default {
  reports: {
    startingDate: {
      label: 'Starting date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    },
    endDate: {
      label: 'End date',
      placeholder: 'YYYY-MM-DD hh:mm:ss'
    }
  },
  accountInformation: {
    placeholder: {
      email: 'Enter your email address',
      name: 'Enter your name',
      country: 'Enter your country name',
      msisdn: 'Enter your phone number',
      callbackUrl: 'Enter your callback URL'
    },
    label: {
      email: 'Email address',
      name: 'Name',
      country: 'Country',
      msisdn: 'Phone number',
      callback: 'Callback URL'
    }
  },
  otp: {
    label: {
      email: 'Code from email',
      sms: 'OTP code'
    },
    placeholder: {
      email: 'Enter OTP code from email',
      sms: 'Enter OTP code from SMS'
    }
  },
  clientSecrets: {
    label: {
      clientId: 'Client Id',
      clientSecret: 'Client Secret',
      savedChanges:
        'I have stored my Client ID and Client Secret. I am aware that I must generate new ones if I misplace them.'
    }
  },
  button: {
    title: {
      create: 'Create',
      update: 'Update',
      cancel: 'Cancel',
      cancelReportGeneration: 'Cancel report generation',
      delete: 'Delete',
      close: 'Close',
      closeWindow: 'Close window',
      backToOtpVerification: 'Back to OTP verification',
      select: 'Select',
      apply: 'Apply'
    }
  },
  operation: {
    label: {
      purpose: 'Purpose',
      amount: 'Amount',
      transferAmount: 'Transfer amount',
      transferTitle: 'Transfer title',
      transferNarration: 'Transfer narration',
      accountNumberIban: 'Account number (IBAN)',
      cost: 'Cost',
      recoveryTokenNotificationMethod: 'Notification Method',
      confirmDate: 'Confirm date',
      customerEmail: 'Customer Email',
      acquirerMsisdn: 'Acquiere phone number',
      customerMsisdn: 'Customer phone number',
      referenceId: 'Reference Id',
      transactionId: 'Transaction Id',
      confirmedCreditAmount: 'Confirmed credit amount',
      failureCause: 'Failure Cause',
      reference: 'Reference',
      externalTransactionId: 'External transaction Id',
      receiver: 'Receiver phone number',
      recipient: 'Recipient phone number',
      productId: 'Product Id',
      operatorName: 'Operator name',
      errorCode: 'Error code',
      shortcode: 'Shortcode',
      appId: 'App Id',
      sessionTag: 'Session tag',
      sessionType: 'Session type',
      sessionCloseReason: 'Session close reason',
      sessionAbortReason: 'Session abort reason',
      dialedShortcodeString: 'Dialed shortcode string',
      dialedAppId: 'Dialed app Id',
      phoneNumber: 'Phone number',
      duration: 'Duration',
      msisdn: 'Phone number',
      detailsMessage: 'Details message',
      rejectDate: 'Reject date',
      senderMsisdn: 'Sender phone number',
      senderEmail: 'Sender email',
      debitBank: 'Debit bank',
      debitAccountNumber: 'Debit account number',
      creditBank: 'Credit bank',
      creditAccountNumber: 'Credit account number',
      name: 'Name',
      bvn: 'BVN',
      accountNumber: 'Account number',
      dateOfBirth: 'Date of Birth',
      type: 'Type',
      bankName: 'Bank name',
      bankCode: 'Bank Code',
      bankAccountNumber: 'Bank Account Number',
      merchantCode: 'Merchant Code',
      providerName: 'Provider name',
      authenticationMethod: 'Authentication method',
      authenticationResult: 'Authentication result',
      customerValidationResult: 'Validation result',
      enrollmentResult: 'Enrollment result',
      smsSenderName: 'Sender name',
      smsMessageContent: 'Message content',
      smsExternalProvider: 'External Provider',
      smsExternalId: 'External identifier',
      smsErrorDescription: 'Error description'
    }
  },
  billing: {
    details: {
      events: {
        ussdSessionExpired: 'USSD session events have expired and cannot be fetched.',
        wapSessionExpired: 'Voice session events have expired and cannot be fetched.',
        voiceSessionExpired: 'Voice session events have expired and cannot be fetched.'
      }
    }
  }
};
